export enum ApplicantType {
  PolicyOwner = 'policy_owner',
  LifeInsured = 'life_insured',
}
